var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":'https://avatars.dicebear.com/api/initials/'+_vm.text+'.svg?fontSize=38',"alt":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }